<ng-template #loading>
  <app-loader-spinner-general
    [loadingType]="LoadingType.INPUT"
  ></app-loader-spinner-general>
  <app-loader-spinner-general
    [loadingType]="LoadingType.INFO"
  ></app-loader-spinner-general>
</ng-template>

<div class="white-box-row" *ngIf="!isLoading; else loading">
  <div class="white-box-header">
    <div class="medium-title fl-l">
      {{ "EBURY.MAPPING.TITLE" | translate }}
    </div>
  </div>
  <div class="clear"></div>
  <div class="white-box-body">
    <div class="ebury-mapping-row">
      <mat-form-field
        appearance="outline"
        subscriptSizing="dynamic"
        class="ebury-mapping-select"
      >
        <mat-label>{{ "EBURY.MAPPING.CLIENT_LABEL" | translate }}</mat-label>
        <mat-select [(ngModel)]="selectedEburyClientId">
          <mat-option [value]="null">
            {{ "EBURY.MAPPING.NONE" | translate }}
          </mat-option>
          <mat-option *ngIf="eburyClients.length === 0" [disabled]="true">
            {{ "EBURY.MAPPING.NO_CLIENTS" | translate }}
          </mat-option>
          <mat-option *ngFor="let client of eburyClients" [value]="client.id">
            {{ client.name ? client.name + " (" + client.id + ")" : client.id }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <button
        class="btn orange-bg"
        (click)="save()"
        [disabled]="!canSave || isSaving"
      >
        {{ "EBURY.MAPPING.SAVE" | translate }}
      </button>
    </div>
  </div>
</div>
